import React from 'react'
import SponsorshipItemView from './sponsorship-item-view'
import TableContainer from '@material-ui/core/TableContainer'
import { useStyles } from './styles'
import EnhancedTable from 'components/tables/enhanced-table'
import NoSponsorships from './no-sponsorships'

const SponsorshipsListView = ({ endorsements, facilities, refetch }) => {
  const classes = useStyles()

  const sortByName = (a, b, dir) => {
    a = a.props.endorsement.name.toLowerCase().replace(/\s/g, '')
    b = b.props.endorsement.name.toLowerCase().replace(/\s/g, '')

    if (a > b) return dir === 'desc' ? 1 : -1
    if (a < b) return dir === 'desc' ? -1 : 1
    return 0
  }

  const sortByStatus = (a, b, dir) => {
    a = a.props.endorsement.status.toLowerCase().replace(/\s/g, '')
    b = b.props.endorsement.status.toLowerCase().replace(/\s/g, '')

    if (a > b) return dir === 'desc' ? 1 : -1
    if (a < b) return dir === 'desc' ? -1 : 1
    return 0
  }

  const sortByExpiredAt = (a, b, dir) => {
    a = a.props.endorsement.expiredAt
    b = b.props.endorsement.expiredAt

    if (a === null) return 0
    if (b === null) return -1
    if (a < b) return dir === 'desc' ? -1 : 1
    if (a === b) return 0
    if (a > b) return dir === 'desc' ? 1 : -1
  }

  const columns = [
    {
      id: 'name',
      label: 'Name',
      align: 'left',
      mobile: true,
      sortable: true,
      sortComparator: sortByName,
    },
    {
      id: 'expiredAt',
      label: 'Access Expiration Date',
      align: 'left',
      mobile: false,
      sortable: true,
      sortComparator: sortByExpiredAt,
    },
    {
      id: 'facility.name',
      label: 'Facility',
      align: 'left',
      mobile: false,
      sortable: false,
    },
    {
      id: 'status',
      label: 'Status',
      align: 'left',
      mobile: true,
      sortable: true,
      sortComparator: sortByStatus,
    },
    {
      id: 'actions',
      label: '',
      align: 'right',
      width: '20%',
      mobile: true,
      sortable: false,
    },
  ]
  const rows = endorsements.map(endorsement => (
    <SponsorshipItemView
      endorsement={endorsement}
      key={endorsement.id}
      refetch={refetch}
    />
  ))

  return (
    <TableContainer className={classes.containerStyles}>
      <EnhancedTable
        rows={rows}
        columns={columns}
        label="Sponsorships"
        emptyState={() => (
          <NoSponsorships facilities={facilities} refetch={refetch} />
        )}
      />
    </TableContainer>
  )
}

export default SponsorshipsListView
